import idx from "idx"
import { CONSTANTS } from "@data"
import { logTool, initCaps, revertSlug } from "./main"

const { CONTENT_PROPERTIES } = CONSTANTS

const log = logTool()

/**
 * Helper utility function
 * Get the content type of a given contentful object
 * @param {object} obj - get the contentful type name string
 */
// eslint-disable-next-line no-underscore-dangle
export const getType = obj => obj?.__typename

/**
 * Safely get the product file download link.
 * @param {object} download file download link
 */
export const getFileLink = download => idx(download, _ => _.file.url)

/**
 * Safety check for (in our case, Contentful) data arrays
 * @param {array} arrayData - array to map over
 * @param {function} cb - callback function for every iteration of the Array.map
 * @returns {array}
 * @example
 *  return getSafeDataMap(myArray, module => resolveComponent(module))
 * @example
 *  const result = getSafeDataMap(myArray, i => i + 1)
 */
export const getSafeDataMap = (arrayData, cb) => {
  // log("getSafeDataMap(): ", arrayData)
  return arrayData && arrayData.map ? arrayData.map(cb) : []
}

/**
 * Helper utility function
 * Get a friendly Contentful name for a slug etc.
 * @param {string} pageName - take a slugified or similar string and make a proper name
 * @see utils and initCaps + revertSlug
 */
export const getFriendlyPageName = pageName => {
  const result = initCaps(revertSlug(pageName))
  // log("getFriendlyPageName()", pageName, result)
  return result
}

/**
 * Return markup suitable for dangerouslySetInnerHTML, including line breaks
 * Some Contentful content is wrapped in P tags but does not include breaks, just newline chars (\n)
 * @param {string|markup} text - text we want to replace newlines with breaks
 * @returns {markup}
 */
export const joinNewLines = text => {
  let result
  try {
    result = text.split("\n").join("<br />")
  } catch (e) {
    log("Issue splitting new lines for JSX <br>.", e)
    return e
  }
  return result
}

/**
 * Helper utility
 * Get either the title or titles and orgs
 * @param {string} title - title string
 * @param {object} orgs - titlesOrganizations contentful object
 * @return {string}
 */
export const titlesAndOrgs = (title, orgs) => {
  let result = ""
  const titleOrgs = idx(orgs, _ => _.childMarkdownRemark.rawMarkdownBody)
  result = joinNewLines(titleOrgs)
  return result || title
}

/**
 * Is the content type in need of a wide layout?
 * @param {string} ctype - contentful content type string
 */
// eslint-disable-next-line no-underscore-dangle
export const isWideLoad = ctype => CONTENT_PROPERTIES.WIDE.includes(getType(ctype))

/**
 * Check a field on a data content object to see if it is a mixed object type or the raw field property only.
 * Specifically, something may be data.field.field, or data.field
 * @param {object} data - data object to check
 * @param {string} field - string field key to check
 * @returns {string}
 */
export const twiceFieldCheck = (data, field) => {
  const rawFieldObj = idx(data, _ => _[field])
  return idx(rawFieldObj, _ => _[field]) || rawFieldObj
}
